import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

const Audio2 = () => {
  return (
    <div>
      <Navbar />
      <div className="text-black ml-20 mt-5">
          <Link to="/mainaudiopage">
            <button className="flex gap-1 px-4 py-2 rounded-xl w-fit"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
              Back
            </button>
          </Link>
      </div>
          <h1 className="text-[#314C1C] text-3xl text-center font-bold pt-2">
          SOOTHING STREAM SOUNDS
          </h1>
        
          <div className="lg:items-center justify-center mx-20 my-5 px-10 py-7 bg-[#DCAE96] mb-10">
            <div className="w-full md:grid md:justify-center md:items-center md:place-content-center">
              <img src="https://res.cloudinary.com/djltdw88d/image/upload/v1700580258/thrive-audio-1-4/y8pc2rzhfzohhieju9il.png"
                  alt="audio-img"
                  className="w-full md:w-[400px] md:h-[250px] rounded-md text-center object-cover"/>
                <audio controls src="https://res.cloudinary.com/djltdw88d/video/upload/v1701287332/audio1-4%20audios/y19rcadxck2k3qrlk1qs.mp3" className=" md:w-[400px]"> </audio>
            </div>
              
            <div className="flex flex-col lg:flex-row lg:gap-16 gap-4 px-4 py-2 mt-5 justify-center">
              <Link to="https://res.cloudinary.com/djltdw88d/video/upload/v1701287332/audio1-4%20audios/y19rcadxck2k3qrlk1qs.mp3"
              >
                <button
                  className="text-[whitesmoke] font-medium bg-[#314C1C] p-3 rounded-md"
                >
                  DOWNLOAD
                </button>
              </Link>
            </div>
            <section className="mt-5 md:mt-5 content-center justify-center items-center place-content-center">
            <div className="content-center justify-center items-center place-content-center px-5">
            <p className="text-[#314C1C] text-md text-justify">
              Amidst the hustle and bustle of our daily lives, there exists a
              refuge of tranquility that can be found in the form of blissful
              sounds. These auditory treasures have the remarkable ability to
              transport us to realms of serenity, evoke emotions, and nurture
              our well-being. Whether they emerge from nature's embrace or
              artistic creations, blissful sounds offer a gateway to inner peace
              and harmony. Blissful sounds are not mere auditory experiences;
              they are pathways to mindfulness, healing, and emotional
              resonance.
            </p>
            </div>
            </section>
          </div>
      <Footer />
    </div>
  );
};

export default Audio2;
